import { Layer, Source } from '@vis.gl/react-maplibre';

import ParkAndRideIcon from '@/assets/icons/map/map-markers/parkride.svg?url';
import { parkAndRideGeoJson } from '@/data/parkAndRideGeoJson';
import { useMapImages } from '@/hooks/useMapImages';

export const PARK_AND_RIDE_LAYER = 'PARK_AND_RIDE_LAYER';
const PARK_AND_RIDE_ICON = 'PARK_AND_RIDE_ICON';

export function ParkAndRideLayer() {
  useMapImages({
    images: [{ name: PARK_AND_RIDE_ICON, url: ParkAndRideIcon, width: 36, height: 36 }],
  });

  return (
    <Source data={parkAndRideGeoJson} id={PARK_AND_RIDE_LAYER} type="geojson">
      <Layer
        id={PARK_AND_RIDE_LAYER}
        type="symbol"
        layout={{
          'icon-allow-overlap': true,
          'icon-image': PARK_AND_RIDE_ICON,
        }}
      />
    </Source>
  );
}
